var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { action, makeObservable, observable } from "mobx";
import { Apphandler } from "@/ipc/MainAppHandler";
import { UserDevice } from "@@/Device";
export class DeviceStore {
    constructor() {
        this.devicesById = new Map();
        this.loading = false;
        this.loaded = false;
        this.deletingreq = new Set();
        makeObservable(this);
        APPEvent.addSubscriberForDevices((dev) => {
            console.log(dev);
            this.setLoading(false);
            this.setLoaded(true);
            dev.forEach((d) => this.addDevice(d));
        });
        APPEvent.addSubscriberForDeleteDevice((res) => {
            if (this.deletingreq.has(res.id)) {
                if (res.ok) {
                    this.devicesById.delete(res.id);
                }
                else {
                    APPEvent.publishApperror("Sorry, failed to delete device");
                }
                this.deletingreq.delete(res.id);
            }
        });
    }
    setLoading(loading) {
        this.loading = loading;
    }
    setLoaded(loaded) {
        this.loaded = loaded;
    }
    deleteDevice(id) {
        if (!this.deletingreq.has(id)) {
            this.deletingreq.add(id);
            const req = {
                deviceid: id
            };
            Apphandler.sendMessage("deletedevice", req);
        }
    }
    addDevice(device) {
        if (!this.devicesById.has(device.id)) {
            this.devicesById.set(device.id, device);
        }
    }
    reset() {
        this.devicesById = new Map();
        this.deletingreq = new Set();
    }
    getAllDevices() {
        return Array.from(this.devicesById.values());
    }
    getCurrentDevice(id) {
        return this.devicesById.get(id);
    }
    loadDevices() {
        if (this.loading) {
            return;
        }
        if (this.devicesById.size === 0) {
            this.setLoading(true);
        }
        Apphandler.sendMessage("devices", "");
    }
}
__decorate([
    observable,
    __metadata("design:type", Map)
], DeviceStore.prototype, "devicesById", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DeviceStore.prototype, "loading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DeviceStore.prototype, "loaded", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], DeviceStore.prototype, "deletingreq", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DeviceStore.prototype, "setLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DeviceStore.prototype, "setLoaded", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], DeviceStore.prototype, "deleteDevice", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UserDevice]),
    __metadata("design:returntype", void 0)
], DeviceStore.prototype, "addDevice", null);
